import { all, spawn } from 'redux-saga/effects';

import bankWiresSaga from './bankWires';
import accountTransfersSaga from './accountTransfers';

export default function* withdrawalsSaga() {
  yield all([accountTransfersSaga, bankWiresSaga].map(spawn));
}
